import { ARC_REPORT_REVISION } from '@common/constants/webSockets'
import {
  IArcReportRevision,
  IReportDetails,
  IReportListItem,
  IReportResult,
} from '@common/interfaces/report'
import omit from 'lodash/omit'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

const SAVING_ACTIONS = [
  actions.CREATE_REPORT_REQUEST,
  actions.UPDATE_REPORT_REQUEST,
  actions.DELETE_REPORT_REQUEST,
  actions.SHARE_REPORT_REQUEST,
]

// The reports the caller can open; the list page refetches after a delete.
const reportsData = createLoadingDataReducer<IReportListItem[] | null>(
  [actions.LIST_REPORTS_REQUEST],
  SAVING_ACTIONS,
)

// The open report; saving flips isSaving and the page refetches it on success.
const reportData = createLoadingDataReducer<IReportDetails | null>(
  [actions.GET_REPORT_REQUEST],
  SAVING_ACTIONS,
)

// The rows scrolled into view so far; an export flips isSaving while the file is built. A page
// asked for under an earlier definition is dropped.
const reportResultData = createLoadingDataReducer<IReportResult | null>(
  [actions.RUN_REPORT_REQUEST],
  [actions.EXPORT_REPORT_REQUEST],
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  { pickQuery: (params) => omit(params, ['page', 'perPage', 'loadMore']) },
)

// The latest report Arc revised on this person's screen; the page with that conversation
// applies it once.
const arcReportRevision = (
  state: IArcReportRevision | null = null,
  action: { type: string; data?: IArcReportRevision },
): IArcReportRevision | null =>
  action.type === ARC_REPORT_REVISION && action.data ? action.data : state

export default combineReducers({
  reportsData,
  reportData,
  reportResultData,
  arcReportRevision,
})
